<script setup>
/**
 * FormSidebar
 * Acts as a container for all secondary actions and metadata for a specific form.
 * Conditionally renders buttons for history, duplication, archiving, and deletion
 * based on component configuration and user context.
 */
import { computed, getCurrentInstance } from 'vue';
import FormPublishBtn from '../../common/form/FormPublishBtn';
import FormDisplayOrderMenu from '../../common/form/FormDisplayOrderMenu';
import FormHistoryBtn from './FormHistoryBtn';
import FormDuplicateBtn from './FormDuplicateBtn';
import FormArchiveBtn from './FormArchiveBtn';
import FormDeleteBtn from './FormDeleteBtn';
import TagsBtn from '../tags/TagsBtn';
import PrintBtn from '../../components/order-details/PrintBtn';
import OrderRequestReview from "../../components/order-details/OrderRequestReview";
import FormCreatedModified from "./FormCreatedModified.vue";
import PageEditorDetachFromPageBtn from "./PageEditorDetachFromPageBtn.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    showHistoryBtn: Boolean,
    showDuplicateBtn: Boolean,
    showArchiveBtn: Boolean,
    alwaysShowDeleteBtn: Boolean
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const currentData = computed(() => store.state[props.formId]?.currentData || {});

const showDisplayOrderOption = computed(() => {
    return store.getters[`${props.formId}/showDisplayOrderOption`];
});
</script>

<template>
    <div>
        <FormPublishBtn :form-id="formId" class="mb-3"/>

        <FormCreatedModified :form-id="formId"/>

        <FormDisplayOrderMenu
            v-if="showDisplayOrderOption && currentData.id"
            :form-id="formId"
            class="mb-2"
        />

        <FormHistoryBtn v-if="showHistoryBtn" :form-id="formId"/>
        <FormDuplicateBtn v-if="showDuplicateBtn" :form-id="formId"/>
        <TagsBtn :form-id="formId"/>

        <OrderRequestReview :form-id="formId"/>
        <PrintBtn :form-id="formId" :is-invoice="true"/>
        <PrintBtn :form-id="formId"/>
        <PageEditorDetachFromPageBtn :form-id="formId"/>

        <FormArchiveBtn v-if="showArchiveBtn" :form-id="formId"/>
        <FormDeleteBtn :form-id="formId" :always-show="alwaysShowDeleteBtn"/>
    </div>
</template>